import { gql } from 'apollo-boost'

const me = gql`
  query me(
    $promemoriaWhere: AzioniFilterInput
    $promemoriaOrderBy: [AzioniOrderBy!]
  ) {
    me {
      id
      nome
      ruolo
      email
      mostraStatisticheAgenti
      promemoria(
        where: $promemoriaWhere
        orderBy: $promemoriaOrderBy
      ) {
        id
        utenteId
        clienteId
        cliente {
          nome
          telefono
        }
        descrizione
        promemoriaDataOra
        promemoriaDismesso
      }
    }
  }
`

export default me


// $appuntamentiWhere: AzioniFilterInput
// $appuntamentiOrderBy: [AzioniOrderBy!]
// assenze {
  //   id
  //   utenteId
  //   utente {
  //     id
  //     nome
  //   }
  //   daDataOra
  //   aDataOra
  //   descrizione
  //   flagOccupato
// }
// appuntamenti(
  //   where: $appuntamentiWhere
  //   orderBy: $appuntamentiOrderBy
  // ) {
  //   id
  //   utenteId
  //   utente {
  //     id
  //     nome
  //   }
  //   clienteId
  //   cliente {
  //     id
  //     nome
  //   }
  //   offertaId
  //   offerta {
  //     id
  //     nome
  //   }
  //   campagnaId
  //   campagna {
  //     id
  //     nome
  //   }
  //   tipoAzioneId
  //   tipoAzione {
  //     id
  //     tipo
  //   }
  //   appuntamentoAgenteId
  //   appuntamentoAgente {
  //     id
  //     nome
  //   }
  //   dataOra
  //   descrizione
  //   appuntamentoDaDataOra
  //   appuntamentoADataOra
  //   appuntamentoLuogo
  //   appuntamentoStato
// }


// WEBPACK FOOTER //
// ./src/graphql/queries/me.js